var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22.6904C9.55228 22.6904 10 22.2427 10 21.6904C10 21.1381 9.55228 20.6904 9 20.6904C8.44772 20.6904 8 21.1381 8 21.6904C8 22.2427 8.44772 22.6904 9 22.6904Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.6904C17.5523 22.6904 18 22.2427 18 21.6904C18 21.1381 17.5523 20.6904 17 20.6904C16.4477 20.6904 16 21.1381 16 21.6904C16 22.2427 16.4477 22.6904 17 22.6904Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.69043H3.30616C3.55218 2.69043 3.67519 2.69043 3.77418 2.73567C3.86142 2.77554 3.93535 2.83965 3.98715 2.92038C4.04593 3.01197 4.06333 3.13375 4.09812 3.37729L4.57143 6.69043M4.57143 6.69043L5.62332 14.4218C5.75681 15.403 5.82355 15.8935 6.0581 16.2628C6.26478 16.5882 6.56108 16.8469 6.91135 17.0078C7.30886 17.1904 7.80394 17.1904 8.79411 17.1904H17.352C18.2945 17.1904 18.7658 17.1904 19.151 17.0208C19.4905 16.8713 19.7818 16.6303 19.9923 16.3247C20.2309 15.978 20.3191 15.5151 20.4955 14.5892L21.8191 7.64012C21.8812 7.31424 21.9122 7.1513 21.8672 7.02393C21.8278 6.9122 21.7499 6.81811 21.6475 6.75845C21.5308 6.69043 21.365 6.69043 21.0332 6.69043H4.57143Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.f972747643e9e27fdd633fd22b028064.svg";
export { ForwardRef as ReactComponent };